import { removeAuthData, saveAuthData } from './common/localeStorageUtils';

import { TokenResponse } from './models/TokenResponse';
import axios from 'axios';

const axiosBearerClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

const getRefreshToken = async ({
  headerConfig,
  refreshToken,
  isSignUp,
  isEditProfile,
  isEditPwd,
}: {
  headerConfig: any;
  refreshToken: string;
  isSignUp: boolean;
  isEditProfile: boolean;
  isEditPwd: boolean;
}) => {
  return axios.post<TokenResponse>(
    `${process.env.REACT_APP_API_BASE_URL}/auth/token/refresh`,
    {
      redirectUri: 'https%3A%2F%2Foauth.pstmn.io%2Fv1%2Fcallback',
      refreshToken: refreshToken,
      isSignUp,
      isEditProfile,
      isChangePassword: isEditPwd,
      clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    },
    headerConfig
  );
};

const jWTIsExpired = (accessTokenExpireOn: number | null) => {
  const unixTime = Math.floor(new Date().getTime() / 1000);

  if (accessTokenExpireOn != null) {
    if (unixTime > accessTokenExpireOn) {
      return true;
    } else {
      return false;
    }
  }
  return true;
};

axiosBearerClient.interceptors.request.use(
  async (config) => {
    config.headers['x-api-key'] = process.env.REACT_APP_X_API_KEY;
    config.headers['Content-Language'] =
      localStorage.getItem('lang') || navigator.language.split('-')[0];
    config.headers['Ocp-Apim-Subscription-Key'] = '3efdec646ba442d39029be3f50b2a2ca';
    const accessToken: string | null = localStorage.getItem('access_token');
    const expire = localStorage.getItem('expires_in');
    const accessTokenExpireIn = expire != null ? Number(expire) : null;
    const expireIn = localStorage.getItem('refresh_token_expires_in');
    const accessRefreshTokenExpireIn = expireIn != null ? Number(expireIn) : null;
    const expireOn = localStorage.getItem('expires_on');
    const accessTokenExpireOn = expireOn != null ? Number(expireOn) : null;

    if (!accessToken || jWTIsExpired(accessTokenExpireOn) === true) {
      const refreshToken = localStorage.getItem('refresh_token');
      const timeNow = new Date().getTime();
      if (
        refreshToken &&
        jWTIsExpired(
          (accessTokenExpireOn ? accessTokenExpireOn : timeNow - (accessTokenExpireIn ?? 0)) +
            (accessRefreshTokenExpireIn ? accessRefreshTokenExpireIn : timeNow)
        ) === false
      ) {
        try {
          const stateFlow = localStorage.getItem('stateFlow')
            ? JSON.parse(localStorage.getItem('stateFlow')!)
            : {};
          const refreshTokenResponse = await getRefreshToken({
            headerConfig: config,
            refreshToken,
            isSignUp: stateFlow.isSignUp,
            isEditProfile: stateFlow.isEditProfile,
            isEditPwd: stateFlow.isEditPwd,
          });
          saveAuthData(refreshTokenResponse.data);
          config.headers['Authorization'] = 'Bearer ' + refreshTokenResponse.data.access_token;
        } catch (error) {
          removeAuthData();
          window.location.replace(`${process.env.REACT_APP_AZURE_B2C_SIGN_OUT_URL}`!);
        }
      } else {
        removeAuthData();
        return config;
      }
    } else {
      config.headers['Authorization'] = 'Bearer ' + accessToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default axiosBearerClient;
